<template>
  <v-list class="py-0" two-line style="width: 100%">
    <v-list-tile
      :class="dark ? 'darken-3':'lighten-3'"
      @click="$emit('click', $event)"
      avatar
      class="grey"
      ripple
    >
      <v-list-tile-avatar v-if="icon">
        <v-icon class="primary" color="white">{{icon}}</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>{{label}}</v-list-tile-content>
      <v-list-tile-action>
        <v-icon>$vuetify.icons.arrowRight</v-icon>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'LActionCard',
  props: {
    icon: {type: String, default: ''},
    label: {type: String, default: ''}
  },
  computed: {
    dark () {
      return this.$vuetify.dark
    }
  }
}
</script>

<style scoped>

</style>
